export const FORCE_LOGIN_KEY = "force_login";

export const validQueryStrings = new Set([
  "phone-number",
  "otp",
  "password",
  "forgot-password",
  "password-change-successful",
  "add-password"
]);
